export const DRAWER_TYPES = {
  DRAWER_OPEN_SET_SELECTED: "DRAWER_OPEN_SET_SELECTED",
  DRAWER_CLOSE_SELECTED: "DRAWER_CLOSE_SELECTED",
};
